// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__FBCk+","left-block":"Footer_left-block__YGA-k","right-block":"Footer_right-block__Nf72R"};